import { colors } from 'game/styles/theme';
import { SVGAttributes } from 'react';

export const EndDoorSprite = (props?: SVGAttributes<SVGRectElement>) => (
  <rect width={190} height={290} fill={colors.white} {...props} />
);

export const DeskSprite = (
  <>
    <path
      fill="none"
      stroke="#916844"
      strokeLinecap="round"
      strokeWidth="10"
      d="M10 129.33L10 219.33"
    />
    <path
      fill="none"
      stroke="#916844"
      strokeLinecap="round"
      strokeWidth="10"
      d="M290 129.33L290 219.33"
    />
    <path fill="#c9d7e4" d="M0 9.33H300V129.33H0z" />
    <path
      fill="#132a49"
      d="M206.54 120h-127c-9.76 0-16.43-2.14-19.81-6.36a10 10 0 01-2.17-7.78c.95-8.29 8-13.56 20-15V17.32a2 2 0 012-2h127a2 2 0 012 2V118a2 2 0 01-2.02 2zM61.39 106.55a6 6 0 001.42 4.7c1.82 2.2 6.18 4.83 16.7 4.83h125.07v-96.8H81.47v73.38a2 2 0 01-1.8 2c-7.81.64-17.31 3.2-18.25 11.74z"
    />
    <path fill="#55c0eb" d="M98.41 33.05H187.63V102.31H98.41z" />
    <path
      fill="#55c0eb"
      d="M59.47 106.14c1.12-10.17 12.38-12.85 20-13.48V17.32h127V118h-127c-22.64 0-20-11.86-20-11.86z"
    />
    <path
      fill="#fff"
      d="M187.64 104.27H98.41a2 2 0 01-2-2V33.05a2 2 0 012-2h89.23a2 2 0 012 2v69.26a2 2 0 01-2 1.96zm-87.27-3.92h85.3V35h-85.3z"
    />
    <path
      fill="#fff"
      d="M180.53 64.2h-24.2a2 2 0 01-2-2V33.05a2 2 0 013.93 0v27.22h22.23a2 2 0 010 3.93z"
    />
    <path
      fill="#fff"
      d="M168.43 104.27a2 2 0 01-2-2V83H143a2 2 0 01-2-2V33.05a2 2 0 013.93 0V79h23.44a2 2 0 012 2v21.32a2 2 0 01-1.94 1.95zM123.36 104.27a2 2 0 01-2-2V64.2h-23a2 2 0 010-3.93h25a2 2 0 012 2v40.08a2 2 0 01-2 1.92z"
    />
    <path
      fill="#132a49"
      d="M59.47 108.11a2 2 0 01-2.06-2V17.32A14.3 14.3 0 0162 6.39c8.1-7.5 24-6.35 24.7-6.3a2 2 0 011.81 2v90.47a1.92 1.92 0 01-.59 1.44 2 2 0 01-1.48.52c-.24 0-23.54-1.64-25 11.84a2 2 0 01-1.97 1.75zM83.9 3.93c-4.55 0-14.09.61-19.2 5.34a10.37 10.37 0 00-3.37 8.05v80.22c6.28-6.59 18.39-7.1 23.3-7V3.94z"
    />
    <path
      fill="#d0d2d3"
      d="M86.59 2.05v90.51s-25.41-2-27.12 13.58h-.1V17.32c0-17.39 27.22-15.27 27.22-15.27z"
    />
    <path
      fill="#ffe3ab"
      d="M235 107.94l-43.68-7.68 51.36-36zm-24.26-12l18.08 3.18L232 81z"
    />
    <path
      fill="#132a49"
      d="M234.91 108.61l-43.68-7.68a.68.68 0 01-.54-.51.66.66 0 01.26-.7l51.36-36a.66.66 0 01.74 0 .69.69 0 01.3.69l-7.68 43.68a.65.65 0 01-.76.52zm-41.84-8.73l41.41 7.28 7.28-41.42zm35.66-.09l-18.08-3.18a.68.68 0 01-.54-.51.66.66 0 01.26-.7l21.25-14.9a.68.68 0 011 .68l-3.18 18.08a.63.63 0 01-.71.53zm-16.25-4.21l15.84 2.79 2.78-15.84z"
    />
    <path
      fill="#132a49"
      d="M199.7 99.09a.74.74 0 01-.45-.27l-1.93-2.77a.65.65 0 01.16-.93.66.66 0 01.94.16l1.93 2.77a.65.65 0 01-.16.93.56.56 0 01-.49.11zM205.19 95.26a.66.66 0 01-.45-.27l-1.93-2.76a.67.67 0 111.1-.77l1.93 2.76a.66.66 0 01-.16.94.63.63 0 01-.49.1zM210.65 91.43a.64.64 0 01-.44-.27l-1.94-2.76a.65.65 0 01.16-.93.66.66 0 01.94.16l1.93 2.76a.66.66 0 01-.16.94.63.63 0 01-.49.1zM216.12 87.61a.71.71 0 01-.45-.28l-1.94-2.76a.67.67 0 011.1-.77l1.94 2.76a.67.67 0 01-.65 1zM221.58 83.78a.71.71 0 01-.45-.28l-1.94-2.76a.67.67 0 011.1-.77l1.94 2.76a.66.66 0 01-.16.94.76.76 0 01-.49.11zM227 80a.74.74 0 01-.45-.27l-1.93-2.77a.65.65 0 01.16-.93.66.66 0 01.94.16l1.93 2.77a.65.65 0 01-.16.93.76.76 0 01-.49.11zM232.51 76.12a.71.71 0 01-.45-.27l-1.94-2.77a.67.67 0 011.1-.77l1.94 2.77a.65.65 0 01-.16.92.67.67 0 01-.49.12zM238 72.29a.74.74 0 01-.45-.27l-1.94-2.77a.67.67 0 011.1-.77l1.94 2.77a.65.65 0 01-.17.93.63.63 0 01-.48.11z"
    />
    <path
      fill="#ffe3ab"
      d="M258.13 61.46L266.1 108.43 272.21 116.88 275.17 106.88 267.18 59.92 258.13 61.46z"
    />
    <path
      fill="#132a49"
      d="M272.73 117.25a.81.81 0 01-.43.28.65.65 0 01-.65-.27l-6.11-8.45a.55.55 0 01-.12-.28l-8-47a.64.64 0 01.54-.75l9-1.54a.65.65 0 01.76.53l8 47a.54.54 0 010 .31l-3 10a.35.35 0 01.01.17zm-6-9.09l5.24 7.25 2.56-8.58-7.83-46.16-7.78 1.33z"
    />
    <path
      fill="#55c0eb"
      d="M262.05 60.37H271.26V108H262.05z"
      style={{ transformBox: 'view-box' }}
      transform="rotate(-9.63 266.75 84.22)"
    />
    <path
      fill="#132a49"
      d="M275.71 107.26a.66.66 0 01-.42.28l-9.08 1.52a.65.65 0 01-.76-.53l-8-47a.64.64 0 01.54-.75l9.05-1.54a.65.65 0 01.76.54l8 47a.64.64 0 01-.09.48zm-9.07.42l7.76-1.32-7.75-45.68-7.77 1.32z"
    />
    <path
      fill="#eb5865"
      d="M258.64 60.66H267.84999999999997V67.42H258.64z"
      style={{ transformBox: 'view-box' }}
      transform="rotate(-9.63 263.364 64.09)"
    />
    <path
      fill="#132a49"
      d="M268.88 67a.77.77 0 01-.43.29l-9.06 1.53a.63.63 0 01-.75-.53l-1.13-6.67a.64.64 0 01.53-.75l9.06-1.54a.64.64 0 01.75.54l1.15 6.64a.65.65 0 01-.12.49zm-9.09.39l7.77-1.32-.91-5.37-7.77 1.3z"
    />
    <path
      fill="#132a49"
      d="M272.9 107.75a.66.66 0 01-.43.28l-3.46.59a.63.63 0 01-.75-.53l-6.84-40.31A.64.64 0 01262 67l3.46-.58a.62.62 0 01.75.53l6.79 40.31a.72.72 0 01-.1.49zm-3.47-.54l2.18-.37-6.62-39-2.17.37z"
    />
    <path
      fill="#666d77"
      d="M269.07 112.55L272.21 116.88 273.73 111.74 269.07 112.55z"
    />
    <path
      fill="#132a49"
      d="M272.73 117.25a.81.81 0 01-.43.28.65.65 0 01-.65-.27l-3.14-4.33a.71.71 0 01-.07-.63.65.65 0 01.51-.39l4.63-.79a.65.65 0 01.75.82l-1.54 5.13a.19.19 0 01-.06.18zm-2.52-4.25l1.73 2.4.85-2.84z"
    />
    <path d="M5 139H295V164H5z" opacity="0.3" />
    <path fill="#839098" d="M0 129.33H300V139.33H0z" />
  </>
);

export const LadderFrontSprite = (
  <>
    <path
      fill="#ffc38d"
      d="M250.5 392.06L227.38 392.06 140.66 12.06 163.78 12.06 250.5 392.06z"
    />
    <path
      fill="#f9a05c"
      d="M244.72 392.06L221.59 392.06 134.88 12.06 158 12.06 244.72 392.06z"
    />
    <path
      fill="none"
      stroke="#603813"
      d="M163.78 12.06L158 12.06 140.66 12.06 134.88 12.06 221.59 392.06 227.38 392.06 244.72 392.06 250.5 392.06 163.78 12.06z"
    />
    <rect
      width="92.5"
      height="11.56"
      x="70.5"
      y="58.31"
      fill="#f9a05c"
      stroke="#603813"
      rx="3"
    />
    <rect
      width="92.5"
      height="11.56"
      x="138"
      y="347.38"
      fill="#f9a05c"
      stroke="#603813"
      rx="3"
    />
    <rect
      width="92.5"
      height="11.56"
      x="124.5"
      y="289.56"
      fill="#f9a05c"
      stroke="#603813"
      rx="3"
    />
    <rect
      width="92.5"
      height="11.56"
      x="111"
      y="231.75"
      fill="#f9a05c"
      stroke="#603813"
      rx="3"
    />
    <rect
      width="92.5"
      height="11.56"
      x="97.5"
      y="173.94"
      fill="#f9a05c"
      stroke="#603813"
      rx="3"
    />
    <rect
      width="92.5"
      height="11.56"
      x="84"
      y="116.13"
      fill="#f9a05c"
      stroke="#603813"
      rx="3"
    />
    <path
      fill="#ffc38d"
      d="M158 392.06L134.88 392.06 48.16 12.06 71.28 12.06 158 392.06z"
    />
    <path
      fill="#f9a05c"
      d="M152.22 392.06L129.09 392.06 42.38 12.06 65.5 12.06 152.22 392.06z"
    />
    <path
      fill="none"
      stroke="#603813"
      d="M71.28 12.06L65.5 12.06 48.16 12.06 42.38 12.06 129.09 392.06 134.88 392.06 152.22 392.06 158 392.06 71.28 12.06z"
    />
    <path
      fill="#f9a05c"
      stroke="#603813"
      d="M0.5 0.5H180.5V12.06H0.5z"
    />
  </>
);

export const LadderBackSprite = (
  <>
    <path
      fill="#d79970"
      d="M167.66 0L98.28 335.31 121.41 335.31 190.78 0 167.66 0z"
    />
    <path
      fill="#d77848"
      d="M161.88 0L92.5 335.31 115.63 335.31 185 0 161.88 0z"
    />
    <path fill="#d77848" d="M75.16 34.69H167.66V46.25H75.16z" />
    <path fill="#d77848" d="M28.91 300.63H121.41V312.19H28.91z" />
    <path fill="#d77848" d="M28.91 247.44H121.41V259H28.91z" />
    <path fill="#d77848" d="M40.47 194.25H132.97V205.81H40.47z" />
    <path fill="#d77848" d="M52.03 141.06H144.53V152.62H52.03z" />
    <path fill="#d77848" d="M63.59 87.88H156.09V99.44H63.59z" />
    <path
      fill="#d79970"
      d="M75.16 0L5.78 335.31 28.91 335.31 98.28 0 75.16 0z"
    />
    <path
      fill="#d77848"
      d="M69.38 0L0 335.31 23.13 335.31 92.5 0 69.38 0z"
    />
  </>
);

export const ConstructionHatFrontSprite = (
  <>
    <path
      fill="#561010"
      d="M69.13 36.08c.07-2 .22-8.57-.81-12.46-1.25-4.74-6.44-10.83-8.65-13.42a23.1 23.1 0 01-2-2.77c-1-1.52-1.91-3-3.48-3.55a4.92 4.92 0 00-1.31-.29 9.42 9.42 0 00-3.88.62h-.09c-.81-.09-4.26-.69-6.53-1.09a9.79 9.79 0 00-4.77-3c-.22 0-.45-.07-.68-.09a13.86 13.86 0 00-7.23 1.59A23.77 23.77 0 0025.55 5C24 5 20.9 5 19.41 6.44A6.91 6.91 0 0017.68 11a20.11 20.11 0 00-4 4.45 34.73 34.73 0 00-5.45 15.61c-4 1.51-6.5 2.83-7.54 3.93l3.47 2.06c2.64-.57 5.28-1 7.88-1.39h.11a138 138 0 0136.63.25c1.45.19 2.85.4 4.17.62h.1c5.3.87 9.55 1.85 12.3 2.56h.06c2.15.55 3.36.93 3.39.94.25.11 1.77-3.03.33-3.95z"
    />
    <path
      fill="#ff9d00"
      d="M70.6 39.42c-.1-.32-.55-1.18-2.46-2.24h-.06a22.11 22.11 0 00-3.88-1.61.49.49 0 01-.31-.61.47.47 0 01.6-.3l.31.1.29-6.13-6.35-2.8-.26 5.64a.48.48 0 01-1 0l.29-6.35a.5.5 0 01.23-.38.48.48 0 01.45 0l7.29 3.22a.47.47 0 01.28.46l-.31 6.74a20.65 20.65 0 012.13.91c.07-2.14.18-8.32-.76-11.89-1.08-4.51-6.34-10.63-8.3-12.93a24.64 24.64 0 01-2.09-2.92c-.91-1.43-1.63-2.55-2.73-3a6.79 6.79 0 00-4.21.34l-.23.07a13.54 13.54 0 00-3.77 5c-.72 1.87-.57 2.64-.39 2.78s.53.1 1.38-.46c2.12-1.39 5.55-3.74 5.59-3.77a.48.48 0 01.54.79s-3.48 2.39-5.6 3.78a3.18 3.18 0 01-1.88.67 1.18 1.18 0 01-.63-.26c-.71-.57-.67-1.87.1-3.87a13.47 13.47 0 013.32-4.7c-1-.15-2.8-.45-6.16-1.06a.56.56 0 01-.29-.16s-2-2.39-4.14-2.79A11.86 11.86 0 0030.68 3a12.83 12.83 0 00-2 1.44A33 33 0 0026 11.7c-.32 1.08-.61 2.1-.94 3a6.7 6.7 0 01-2.78 3.3 8.82 8.82 0 00-2.68 2.75c-1.7 2.89-2.37 8.28-2.38 8.33a.47.47 0 01-.52.42.48.48 0 01-.42-.53c0-.23.7-5.64 2.5-8.71a9.86 9.86 0 012.94-3 5.83 5.83 0 002.43-2.82c.31-.87.6-1.88.91-3a51.58 51.58 0 011.73-5.18c-.14.14-.23.22-.23.23C24.58 8.23 23.28 11 22.32 13c-.79 1.67-1.2 2.48-1.74 2.7a1.25 1.25 0 01-.6.09 1 1 0 01-.47-.17 1.71 1.71 0 01-.51-1.39.48.48 0 111 0 1 1 0 00.11.54.3.3 0 00.16 0 9.44 9.44 0 001.24-2.21 24.11 24.11 0 013.63-6c-1.44 0-3.52.19-4.39 1-1.36 1.31-1.28 4-1.28 4a.46.46 0 01-.21.42c-.08 0-7.5 5.15-9.22 19.17 2.38-.86 4.34-1.46 4.53-1.51a.48.48 0 01.6.32.47.47 0 01-.32.59C14.69 30.6 4.21 33.8 2 36.1c-.23.25-.31.44-.26.58.24.61 5.07-.15 2.69.37h-.11a.5.5 0 01-.43-.38.48.48 0 01.37-.57c2.64-.57 5.28-1 7.88-1.39h.11a138.12 138.12 0 0136.64.29c1.45.19 2.84.4 4.16.62h.1c5.3.87 9.55 1.85 12.3 2.56h.06c2.15.55 3.36.93 3.39.94a.48.48 0 01.31.6c-.08.28 1.49 0 1.39-.3zm-19.42-8.26a.47.47 0 01-.55.39c-.18 0-17.39-3-31.25-1.46a.17.17 0 01-.1 0 .47.47 0 01-.43-.42.48.48 0 01.42-.53 111.5 111.5 0 0121.63.21 19.11 19.11 0 00-.28-6.74 8.53 8.53 0 00-3.1-4.17 6.7 6.7 0 01-2-2.23c-.83-2-.44-6.72.42-9.72.95-3.33 2.84-3.56 2.92-3.57a.48.48 0 01.11 1s-1.35.22-2.11 2.88c-.89 3.09-1.11 7.51-.46 9.09a6.38 6.38 0 001.7 1.87 9.44 9.44 0 013.4 4.64 20 20 0 01.31 7.08c5.23.53 8.85 1.15 8.93 1.17a.47.47 0 01.44.51z"
    />
    <path
      fill="#ffce00"
      d="M1.77 36.68c.24.61 5.07-.15 2.69.37h-.14a.5.5 0 01-.43-.38.48.48 0 01.37-.57c2.64-.57 5.28-1 7.88-1.39h.11a138.12 138.12 0 0136.64.29c1.45.19 2.84.4 4.16.62h.1c1.18.19 2.3.39 3.36.59-.3-3.79-2.2-3.65-2.2-3.65s-.32-9.08 1-9.44 5.69.19 5.42-2.94-4-6.83-8.49-7.08S49 15 46.48 16.05s-4-.93-3.81-3.21 2.59-5.24 2.51-6.59a1.22 1.22 0 00-.77-1.18L43.87 5 42 4.64a.56.56 0 01-.29-.16s-2-2.39-4.14-2.79A11.86 11.86 0 0030.68 3a12.83 12.83 0 00-2 1.44A33 33 0 0026 11.7c-.32 1.08-.61 2.1-.94 3a6.7 6.7 0 01-2.78 3.3 8.82 8.82 0 00-2.68 2.75c-1.7 2.89-2.37 8.28-2.38 8.33a.47.47 0 01-.52.42.48.48 0 01-.42-.53c0-.23.7-5.64 2.5-8.71a9.86 9.86 0 012.94-3 5.83 5.83 0 002.43-2.82c.31-.87.6-1.88.91-3a51.58 51.58 0 011.73-5.18c-.14.14-.23.22-.23.23C24.58 8.23 23.28 11 22.32 13c-.79 1.67-1.2 2.48-1.74 2.7a1.25 1.25 0 01-.6.09 1 1 0 01-.47-.17 1.71 1.71 0 01-.51-1.39.48.48 0 111 0 1 1 0 00.11.54.3.3 0 00.16 0 9.44 9.44 0 001.24-2.21 24.11 24.11 0 013.63-6c-1.44 0-3.52.19-4.39 1-1.36 1.31-1.28 4-1.28 4a.46.46 0 01-.21.42c-.08 0-7.5 5.15-9.22 19.17 2.38-.86 4.34-1.46 4.53-1.51a.48.48 0 01.6.32.47.47 0 01-.32.59C14.69 30.6 4.21 33.8 2 36.1c-.2.25-.28.44-.23.58zm17.5-7.54a111.5 111.5 0 0121.63.21 19.11 19.11 0 00-.28-6.74 8.53 8.53 0 00-3.1-4.17 6.7 6.7 0 01-2-2.23c-.83-2-.44-6.72.42-9.72.95-3.33 2.84-3.56 2.92-3.57a.48.48 0 01.11 1s-1.35.22-2.11 2.88c-.89 3.09-1.11 7.51-.46 9.09a6.38 6.38 0 001.7 1.87 9.44 9.44 0 013.4 4.64 20 20 0 01.31 7.08c5.23.53 8.85 1.15 8.93 1.17a.47.47 0 01.39.55.47.47 0 01-.55.39c-.18 0-17.39-3-31.25-1.46a.17.17 0 01-.1 0 .47.47 0 01-.43-.42.48.48 0 01.47-.57z"
    />
  </>
);

export const ConstructionHatBackSprite = (
  <>
    <path
      fill="#561010"
      d="M10.16 40.06l-1.36-.12C3.13 39.4.69 38.62.12 37.15A2 2 0 01.69 35c1-1.1 3.57-2.42 7.54-3.93a34.73 34.73 0 015.45-15.62 20.11 20.11 0 014-4.45 6.91 6.91 0 011.73-4.55C20.9 5 24 5 25.55 5a23.77 23.77 0 014.15-3.4A13.86 13.86 0 0136.94 0c.23 0 .46 0 .68.09a9.79 9.79 0 014.77 3c2.27.4 5.72 1 6.53 1.09h.09a9.42 9.42 0 013.91-.62 4.92 4.92 0 011.31.29c1.57.58 2.5 2 3.48 3.55a23.1 23.1 0 002 2.77c2.21 2.59 7.4 8.68 8.65 13.42 1 3.89.88 10.5.81 12.46a5.75 5.75 0 012.65 2.79 2.32 2.32 0 01-.36 2.16 3.85 3.85 0 01-1.68 1.18"
    />
    <path
      fill="#ff9d00"
      d="M65.53 41.81c1.8-.23 4.39-.81 5-1.6a.82.82 0 00.11-.79c-.1-.32-.55-1.18-2.46-2.24h-.06a22.11 22.11 0 00-3.88-1.61.49.49 0 01-.31-.61.47.47 0 01.6-.3l.31.1.29-6.13-6.35-2.8-.26 5.64a.48.48 0 01-1 0l.29-6.35a.5.5 0 01.23-.38.48.48 0 01.45 0l7.29 3.22a.47.47 0 01.28.46l-.31 6.74a20.65 20.65 0 012.13.91c.07-2.14.18-8.32-.76-11.89-1.12-4.51-6.38-10.63-8.34-12.93a24.64 24.64 0 01-2.09-2.92c-.91-1.43-1.63-2.55-2.73-3a6.79 6.79 0 00-4.21.34l-.23.07a13.54 13.54 0 00-3.77 5c-.72 1.87-.57 2.64-.39 2.78s.53.1 1.38-.46c2.12-1.39 5.55-3.74 5.59-3.77a.48.48 0 01.54.79s-3.48 2.39-5.6 3.78a3.18 3.18 0 01-1.88.67 1.18 1.18 0 01-.63-.26c-.71-.57-.67-1.87.1-3.87a13.47 13.47 0 013.32-4.7c-1-.15-2.8-.45-6.16-1.06a.56.56 0 01-.29-.16s-2-2.39-4.14-2.79A11.86 11.86 0 0030.68 3a12.83 12.83 0 00-2 1.44A33 33 0 0026 11.7c-.32 1.08-.61 2.1-.94 3a6.7 6.7 0 01-2.78 3.3 8.82 8.82 0 00-2.68 2.75c-1.7 2.89-2.37 8.28-2.38 8.33a.47.47 0 01-.52.42.48.48 0 01-.42-.53c0-.23.7-5.64 2.5-8.71a9.86 9.86 0 012.94-3 5.83 5.83 0 002.43-2.82c.31-.87.6-1.88.91-3a51.58 51.58 0 011.73-5.18c-.14.14-.23.22-.23.23C24.58 8.23 23.28 11 22.32 13c-.79 1.67-1.2 2.48-1.74 2.7a1.25 1.25 0 01-.6.09 1 1 0 01-.47-.17 1.71 1.71 0 01-.51-1.39.48.48 0 111 0 1 1 0 00.11.54.3.3 0 00.16 0 9.44 9.44 0 001.24-2.21 24.11 24.11 0 013.63-6c-1.44 0-3.52.19-4.39 1-1.36 1.31-1.28 4-1.28 4a.46.46 0 01-.21.42c-.08 0-7.5 5.15-9.22 19.17 2.38-.86 4.34-1.46 4.53-1.51a.48.48 0 01.6.32.47.47 0 01-.32.59C14.69 30.6 4.21 33.8 2 36.1c-.23.25-.31.44-.26.58.24.61 2.06 1.45 9.27 2a17.67 17.67 0 01.52-2.9c-2.35.34-4.72.75-7.1 1.27h-.11a.5.5 0 01-.43-.38.48.48 0 01.37-.57c2.64-.57 5.28-1 7.88-1.39h.11a138.12 138.12 0 0136.64.29c1.45.19 2.84.4 4.16.62h.1c5.3.87 9.55 1.85 12.3 2.56h.06c2.15.55 3.36.93 3.39.94a.48.48 0 01-.29.92s-1-.33-2.84-.8zM51.18 31.16a.47.47 0 01-.55.39c-.18 0-17.39-3-31.25-1.46a.17.17 0 01-.1 0 .47.47 0 01-.43-.42.48.48 0 01.42-.53 111.5 111.5 0 0121.63.21 19.11 19.11 0 00-.28-6.74 8.53 8.53 0 00-3.1-4.17 6.7 6.7 0 01-2-2.23c-.83-2-.44-6.72.42-9.72.95-3.33 2.84-3.56 2.92-3.57a.48.48 0 01.11 1s-1.35.22-2.11 2.88c-.89 3.09-1.11 7.51-.46 9.09a6.38 6.38 0 001.7 1.87 9.44 9.44 0 013.4 4.64 20 20 0 01.31 7.08c5.23.53 8.85 1.15 8.93 1.17a.47.47 0 01.44.51z"
    />
    <path
      fill="#ffce00"
      d="M1.77 36.68c.24.61 2.06 1.45 9.27 2a17.67 17.67 0 01.52-2.9c-2.35.34-4.72.75-7.1 1.27h-.14a.5.5 0 01-.43-.38.48.48 0 01.37-.57c2.64-.57 5.28-1 7.88-1.39h.11a138.12 138.12 0 0136.64.29c1.45.19 2.84.4 4.16.62h.1c1.18.19 2.3.39 3.36.59-.3-3.79-2.2-3.65-2.2-3.65s-.32-9.08 1-9.44 5.69.19 5.42-2.94-4-6.83-8.49-7.08S49 15 46.48 16.05s-4-.93-3.81-3.21 2.59-5.24 2.51-6.59a1.22 1.22 0 00-.77-1.18L43.87 5 42 4.64a.56.56 0 01-.29-.16s-2-2.39-4.14-2.79A11.86 11.86 0 0030.68 3a12.83 12.83 0 00-2 1.44A33 33 0 0026 11.7c-.32 1.08-.61 2.1-.94 3a6.7 6.7 0 01-2.78 3.3 8.82 8.82 0 00-2.68 2.75c-1.7 2.89-2.37 8.28-2.38 8.33a.47.47 0 01-.52.42.48.48 0 01-.42-.53c0-.23.7-5.64 2.5-8.71a9.86 9.86 0 012.94-3 5.83 5.83 0 002.43-2.82c.31-.87.6-1.88.91-3a51.58 51.58 0 011.73-5.18c-.14.14-.23.22-.23.23C24.58 8.23 23.28 11 22.32 13c-.79 1.67-1.2 2.48-1.74 2.7a1.25 1.25 0 01-.6.09 1 1 0 01-.47-.17 1.71 1.71 0 01-.51-1.39.48.48 0 111 0 1 1 0 00.11.54.3.3 0 00.16 0 9.44 9.44 0 001.24-2.21 24.11 24.11 0 013.63-6c-1.44 0-3.52.19-4.39 1-1.36 1.31-1.28 4-1.28 4a.46.46 0 01-.21.42c-.08 0-7.5 5.15-9.22 19.17 2.38-.86 4.34-1.46 4.53-1.51a.48.48 0 01.6.32.47.47 0 01-.32.59C14.69 30.6 4.21 33.8 2 36.1c-.2.25-.28.44-.23.58zm17.5-7.54a111.5 111.5 0 0121.63.21 19.11 19.11 0 00-.28-6.74 8.53 8.53 0 00-3.1-4.17 6.7 6.7 0 01-2-2.23c-.83-2-.44-6.72.42-9.72.95-3.33 2.84-3.56 2.92-3.57a.48.48 0 01.11 1s-1.35.22-2.11 2.88c-.89 3.09-1.11 7.51-.46 9.09a6.38 6.38 0 001.7 1.87 9.44 9.44 0 013.4 4.64 20 20 0 01.31 7.08c5.23.53 8.85 1.15 8.93 1.17a.47.47 0 01.39.55.47.47 0 01-.55.39c-.18 0-17.39-3-31.25-1.46a.17.17 0 01-.1 0 .47.47 0 01-.43-.42.48.48 0 01.47-.57z"
    />
  </>
);

export const TearDropSprite = (
  <>
    <path
      fill="#9bb3d7"
      d="M20.23 30.34c0 5.25-4.27 8.92-9.52 8.92s-9.52-3.67-9.52-8.92S8.33 1.19 10.71 1.19s9.52 23.89 9.52 29.15z"
    />
    <path
      fill="#edf4f7"
      d="M10.71 40.45C4.6 40.45 0 36.1 0 30.34c0-3 2-10.89 3.92-16.9C8.14 0 9.81 0 10.71 0s2.56 0 6.78 13.44c1.89 6 3.93 13.87 3.93 16.9 0 5.76-4.61 10.11-10.71 10.11zm0-37.77C8.3 6 2.38 25.36 2.38 30.34c0 4.41 3.58 7.73 8.33 7.73S19 34.75 19 30.34C19 25.36 13.12 6 10.71 2.68z"
      style={{ filter: 'drop-shadow(0 0 3px white)' }}
    />
    <path
      fill="#6f8ebc"
      d="M17.49 30.7c0 3.46-3 5.87-6.78 5.87s-6.79-2.41-6.79-5.87 1.85-8.93 6.79-8.93 6.78 5.47 6.78 8.93z"
    />
    <path
      fill="#fff"
      d="M16 20.94c.33 2-.32 3.52-1.39 3.69s-2.17-1.06-2.5-3-1.8-10.55.12-11.33S15.65 19 16 20.94z"
    />
  </>
);
